// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Hooks = require("../../../utils/Hooks.bs.js");
let Utils = require("../../../utils/Utils.bs.js");
let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Scroll = require("../../../reason/common/Scroll/Scroll.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let AuthSession = require("../../../utils/AuthSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let GraphQLWSClient = require("../../../GraphQLWSClient.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let RescriptRelay_Subscriptions = require("rescript-relay/src/RescriptRelay_Subscriptions.bs.js");
let ConversationPageConversationMessagesMessage = require("./ConversationPageConversationMessagesMessage.bs.js");
let ConversationPageConversationMessagesRefetchQuery_graphql = require("../../../__generated__/ConversationPageConversationMessagesRefetchQuery_graphql.bs.js");
let ConversationPageConversationMessages_conversation_graphql = require("../../../__generated__/ConversationPageConversationMessages_conversation_graphql.bs.js");
let ConversationPageConversationMessages_ConversationEventsSubscription_graphql = require("../../../__generated__/ConversationPageConversationMessages_ConversationEventsSubscription_graphql.bs.js");
let ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql = require("../../../__generated__/ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.bs.js");

function ConversationPageConversationMessages$MessagesContainer(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    ref: props.forwardRef,
    className: "h-auto max-h-[519px] overflow-auto px-2"
  });
}

let MessagesContainer = {
  make: ConversationPageConversationMessages$MessagesContainer
};

let getConnectionNodes = ConversationPageConversationMessages_conversation_graphql.Utils.getConnectionNodes;

let convertFragment = ConversationPageConversationMessages_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageConversationMessages_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageConversationMessages_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageConversationMessages_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageConversationMessages_conversation_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = ConversationPageConversationMessagesRefetchQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = ConversationPageConversationMessagesRefetchQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(ConversationPageConversationMessages_conversation_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

function usePagination(fRef) {
  return RescriptRelay_Fragment.usePaginationFragment(ConversationPageConversationMessages_conversation_graphql.node, fRef, convertFragment, convertRefetchVariables);
}

let ConversationFragment_incomingMessageStatusState_decode = ConversationPageConversationMessages_conversation_graphql.Utils.incomingMessageStatusState_decode;

let ConversationFragment_incomingMessageStatusState_fromString = ConversationPageConversationMessages_conversation_graphql.Utils.incomingMessageStatusState_fromString;

let ConversationFragment = {
  getConnectionNodes: getConnectionNodes,
  incomingMessageStatusState_decode: ConversationFragment_incomingMessageStatusState_decode,
  incomingMessageStatusState_fromString: ConversationFragment_incomingMessageStatusState_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable,
  usePagination: usePagination
};

let convertVariables = ConversationPageConversationMessages_ConversationEventsSubscription_graphql.Internal.convertVariables;

let convertResponse = ConversationPageConversationMessages_ConversationEventsSubscription_graphql.Internal.convertResponse;

let subscribe = RescriptRelay_Subscriptions.subscribe(ConversationPageConversationMessages_ConversationEventsSubscription_graphql.node, convertVariables, convertResponse);

let Subscription = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  subscribe: subscribe
};

function ConversationPageConversationMessages$ContextEventMessage(props) {
  let link = props.link;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(IconV5.make, {
          icon: "megaphone-alt",
          size: 30
        }),
        className: "mr-2.5"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          props.text,
          link !== undefined ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ButtonsV5.Link.make, {
                href: link.href,
                className: "underline text-gray-700",
                children: link.text
              }),
              className: "mt-4"
            }) : null
        ],
        className: "bg-gray-100 border px-4 py-2 rounded-sm"
      })
    ],
    className: "flex flex-row space-x-2"
  });
}

let ContextEventMessage = {
  make: ConversationPageConversationMessages$ContextEventMessage
};

let convertVariables$1 = ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.Internal.convertVariables;

let convertResponse$1 = ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse);

let MarkConversationMessagesAsReadV5Mutation_incomingMessageStatusState_decode = ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.Utils.incomingMessageStatusState_decode;

let MarkConversationMessagesAsReadV5Mutation_incomingMessageStatusState_fromString = ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.Utils.incomingMessageStatusState_fromString;

let MarkConversationMessagesAsReadV5Mutation = {
  incomingMessageStatusState_decode: MarkConversationMessagesAsReadV5Mutation_incomingMessageStatusState_decode,
  incomingMessageStatusState_fromString: MarkConversationMessagesAsReadV5Mutation_incomingMessageStatusState_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function ConversationPageConversationMessages(props) {
  let match = useRefetchable(props.conversation);
  let refetch = match[1];
  let conversation = match[0];
  let match$1 = use$1();
  let markAsRead = match$1[0];
  let isImpersonated = AuthSession.useIsImpersonated();
  let match$2 = React.useTransition();
  let startTransition = match$2[1];
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  let messages = getConnectionNodes(conversation.conversationTimeline);
  let unreadMessages = messages.filter(m => {
    if (m.__typename !== "ConversationMessageV5") {
      return false;
    }
    let match = m.status;
    if (match === undefined) {
      return false;
    }
    if (match.__typename !== "IncomingMessageStatus") {
      return false;
    }
    let tmp = match.state;
    return tmp === "NEW";
  });
  let messagesReadElementRef = React.useRef(undefined);
  let messagesListRef = React.useRef(undefined);
  let scrollMessagesToBottom = () => {
    let current = messagesListRef.current;
    if (current === undefined) {
      return;
    }
    let current$1 = Primitive_option.valFromOption(current);
    current$1.scrollTop = current$1.scrollHeight;
  };
  let markAsReadDispatchedAt = React.useRef(undefined);
  let markAsRead$1 = () => {
    let match = markAsReadDispatchedAt.current;
    let match$1 = messagesReadElementRef.current;
    let match$2 = Stdlib_Array.filterMap(messages, m => {
        if (m.__typename === "ConversationMessageV5") {
          return m.id;
        }
      })[messages.length - 1 | 0];
    if (match !== undefined) {
      return;
    }
    if (match$1 === undefined) {
      return;
    }
    if (match$2 === undefined) {
      return;
    }
    if (!(!isImpersonated && Scroll.isElementInView(Primitive_option.valFromOption(match$1)) && unreadMessages.length !== 0)) {
      return;
    }
    markAsReadDispatchedAt.current = Date.now();
    let unmarkAsDispatched = () => {
      let match = markAsReadDispatchedAt.current;
      if (match !== undefined) {
        markAsReadDispatchedAt.current = undefined;
        return;
      }
    };
    markAsRead({
      input: {
        conversationId: conversation.id,
        lastReadMessageId: match$2
      }
    }, undefined, undefined, undefined, (param, param$1) => unmarkAsDispatched(), param => unmarkAsDispatched(), undefined);
  };
  Hooks.useEventListenerOnDocument(true, param => markAsRead$1(), "scroll");
  React.useLayoutEffect(() => {
    scrollMessagesToBottom();
  }, [conversation]);
  React.useEffect(() => {
    markAsRead$1();
  }, [conversation]);
  React.useEffect(() => {
    let subscription = subscribe(environment, {
      connections: [ConversationPageConversationMessages_conversation_graphql.makeConnectionId(conversation.__id)],
      conversationId: conversation.id
    }, undefined, undefined, undefined, undefined);
    return () => {
      subscription.dispose();
    };
  }, [
    conversation.id,
    conversation.__id
  ]);
  let refetchMessages = React.useCallback(() => startTransition(() => {
    refetch(makeRefetchVariables(undefined, undefined, conversation.nodeId), "network-only", undefined);
  }), [
    refetch,
    startTransition,
    conversation.nodeId
  ]);
  let wsIsClosed = React.useRef(false);
  let onWsStatusUpdated = React.useCallback(status => {
    let match = wsIsClosed.current;
    switch (status) {
      case "Closed" :
        wsIsClosed.current = true;
        return;
      case "Connecting" :
        return;
      case "Connected" :
        if (match) {
          refetchMessages();
          wsIsClosed.current = false;
          return;
        } else {
          return;
        }
    }
  }, [refetchMessages]);
  GraphQLWSClient.useOnWsStatusUpdated(onWsStatusUpdated);
  let lastPrintedDay = {
    contents: undefined
  };
  let today = DateFns.format(new Date(), "MM/dd/yyyy");
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(ConversationPageConversationMessages$MessagesContainer, {
        children: messages.map(item => {
          let dateForItem;
          switch (item.__typename) {
            case "ConversationMessageV5" :
              dateForItem = item.sentAt;
              break;
            case "__unselected" :
              dateForItem = undefined;
              break;
            default:
              dateForItem = item.broadcastAt;
          }
          let key;
          switch (item.__typename) {
            case "ConversationMessageV5" :
              key = item.id;
              break;
            case "__unselected" :
              key = "";
              break;
            default:
              key = item.id;
          }
          let dayForItem = DateFns.format(dateForItem !== undefined ? UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(Primitive_option.valFromOption(dateForItem))) : new Date(), "MM/dd/yyyy");
          let tmp;
          switch (item.__typename) {
            case "BuyerNeedBroadcast" :
              let content = item.content;
              let tmp$1;
              tmp$1 = content !== undefined && content.__typename === "BuyerNeedV5" ? ({
                  text: "Click here to view the buyer need page",
                  href: "/client_needs/" + content.id
                }) : undefined;
              tmp = JsxRuntime.jsx(ConversationPageConversationMessages$ContextEventMessage, {
                text: "The buyer need was broadcast",
                link: tmp$1
              });
              break;
            case "ConversationMessageV5" :
              tmp = JsxRuntime.jsx(ConversationPageConversationMessagesMessage.make, {
                message: item.fragmentRefs,
                conversation: conversation.fragmentRefs
              }, item.id);
              break;
            case "ForSalePropertyBroadcast" :
              let content$1 = item.content;
              let tmp$2;
              tmp$2 = content$1 !== undefined && content$1.__typename === "ForSalePropertyV5" ? ({
                  text: "Click here to view the property page",
                  href: "/properties/" + content$1.id
                }) : undefined;
              tmp = JsxRuntime.jsx(ConversationPageConversationMessages$ContextEventMessage, {
                text: "The property was broadcast",
                link: tmp$2
              });
              break;
            case "RentalNeedBroadcast" :
              let content$2 = item.content;
              let tmp$3;
              tmp$3 = content$2 !== undefined && content$2.__typename === "RentalNeedV5" ? ({
                  text: "Click here to view the rental need page",
                  href: "/client_needs/" + content$2.id
                }) : undefined;
              tmp = JsxRuntime.jsx(ConversationPageConversationMessages$ContextEventMessage, {
                text: "The rental need was broadcast",
                link: tmp$3
              });
              break;
            case "RentalPropertyBroadcast" :
              let content$3 = item.content;
              let tmp$4;
              tmp$4 = content$3 !== undefined && content$3.__typename === "RentalPropertyV5" ? ({
                  text: "Click here to view the property page",
                  href: "/properties/" + content$3.id
                }) : undefined;
              tmp = JsxRuntime.jsx(ConversationPageConversationMessages$ContextEventMessage, {
                text: "The rental property was broadcast",
                link: tmp$4
              });
              break;
            case "__unselected" :
              tmp = null;
              break;
          }
          return JsxRuntime.jsxs("div", {
            children: [
              dayForItem !== lastPrintedDay.contents ? (lastPrintedDay.contents = dayForItem, JsxRuntime.jsx("div", {
                  children: dayForItem === today ? "Today, " + dayForItem : dayForItem,
                  className: "text-center text-gray-600 text-xs mt-4 mb-8"
                })) : null,
              tmp
            ],
            className: "my-4"
          }, key);
        }),
        forwardRef: Primitive_option.some(e => {
          Utils.React.setCurrentRef(messagesListRef, (e == null) ? undefined : Primitive_option.some(e));
        })
      }),
      JsxRuntime.jsx("span", {
        ref: Primitive_option.some(e => {
          Utils.React.setCurrentRef(messagesReadElementRef, (e == null) ? undefined : Primitive_option.some(e));
        })
      })
    ]
  });
}

let make = ConversationPageConversationMessages;

exports.MessagesContainer = MessagesContainer;
exports.ConversationFragment = ConversationFragment;
exports.Subscription = Subscription;
exports.ContextEventMessage = ContextEventMessage;
exports.MarkConversationMessagesAsReadV5Mutation = MarkConversationMessagesAsReadV5Mutation;
exports.make = make;
/* subscribe Not a pure module */
